'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateFns = require('date-fns');

var _DropDown = require('../../DropDown/DropDown');

var _DropDown2 = _interopRequireDefault(_DropDown);

var _WeekPicker = require('../WeekPicker/WeekPicker');

var _WeekPicker2 = _interopRequireDefault(_WeekPicker);

var _DateEditMode = require('../DateEditMode/DateEditMode');

var _DateEditMode2 = _interopRequireDefault(_DateEditMode);

var _date = require('../lib/date.date');

var _date2 = _interopRequireDefault(_date);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Libs


var WeekPickerInput = function (_Component) {
  _inherits(WeekPickerInput, _Component);

  function WeekPickerInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WeekPickerInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WeekPickerInput.__proto__ || Object.getPrototypeOf(WeekPickerInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      visible: false
    }, _this.hidden = true, _this.show = function () {
      _this.hidden = false;

      _this.setState({
        visible: true
      });
    }, _this.hide = function () {
      _this.setState({
        visible: false
      });
    }, _this.onChange = function () {
      var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return function (val) {
        _this.hidden = true;
        if (hide) _this.hide();

        _this.props.onChange(val);
      };
    }, _this.onEdit = function (date) {
      if (_this.hidden) return;

      _this.props.onChange((0, _dateFns.format)((0, _dateFns.startOfWeek)(date, {
        weekStartsOn: 1
      }), 'YYYY-MM-DD'));
    }, _this.dateFormat = function (val) {
      var _this$props = _this.props,
          dateFormat = _this$props.dateFormat,
          dateSeparator = _this$props.dateSeparator;
      var start = (0, _dateFns.format)((0, _dateFns.startOfWeek)(val, {
        weekStartsOn: 1
      }), 'YYYY-MM-DD');
      var end = (0, _dateFns.format)((0, _dateFns.endOfWeek)(val, {
        weekStartsOn: 1
      }), 'YYYY-MM-DD');
      return !!val ? '' + dateFormat(start) + dateSeparator + dateFormat(end) : '';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WeekPickerInput, [{
    key: 'renderInput',
    value: function renderInput() {
      var _props = this.props,
          value = _props.value,
          size = _props.size,
          children = _props.children,
          placeholder = _props.placeholder,
          disabled = _props.disabled,
          disabledDates = _props.disabledDates,
          error = _props.error,
          red = _props.red;
      var visible = this.state.visible;
      return _react2.default.createElement(_DateEditMode2.default, {
        object: _date2.default,
        onChange: this.onEdit,
        size: size,
        label: children,
        editMode: visible,
        onFocus: this.show,
        onBlur: this.hide,
        placeholder: placeholder,
        disabled: disabled,
        rawValue: value,
        dateFormat: this.dateFormat,
        disabledDates: disabledDates,
        error: error,
        red: red
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          value = _props2.value,
          disabledDates = _props2.disabledDates;
      var visible = this.state.visible;
      return _react2.default.createElement(_DropDown2.default, {
        visible: visible,
        trigger: this.renderInput(),
        onClose: this.hide,
        block: true
      }, _react2.default.createElement(_WeekPicker2.default, {
        value: value,
        onChange: this.onChange(true),
        disabledDates: disabledDates
      }));
    }
  }]);

  return WeekPickerInput;
}(_react.Component);

WeekPickerInput.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.string,
  children: _propTypes2.default.node,
  placeholder: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  disabledDates: _propTypes2.default.array,
  dateFormat: _propTypes2.default.func,
  error: _propTypes2.default.bool,
  red: _propTypes2.default.bool,
  dateSeparator: _propTypes2.default.string
};
WeekPickerInput.defaultProps = {
  size: 'normal',
  children: null,
  placeholder: '',
  disabled: false,
  red: false,
  dateFormat: function dateFormat(val) {
    return val;
  },
  disabledDates: [],
  dateSeparator: ' - '
};
exports.default = WeekPickerInput;